module.exports = __webpack_public_path__ + "img/hzgs2.86d32d08.png";